import React, { Component } from 'react'
import { Input, Button, Dropdown, Menu, Icon, Checkbox } from '@tinper/next-ui'
import './style';
import { REFER_TYPE } from '../../utils/refer_context/referType';
import { v4 as uuid } from 'uuid'
import render from 'ynf-core-engine/render'

const { Item } = Menu;
const X_LIB_CODE = 'ynf-lib-base' // 组件库名

export default class ReferTablePc extends Component {
  referContext = this.props.referContext;
  billNo = this.referContext.props.pageStore.params.billNo;
  busiObj = this.referContext.props.pageStore.params.busiObj;
  key = this.referContext.metaDataObj.cEntityKeyFld || 'id'; // 参照主键
  name = this.props.topName ? this.referContext.metaDataObj.cEntityNameFld : (typeof this.referContext.props.refReturn === 'object' ? this.referContext.props.refReturn[0] : this.referContext.props.refReturn); // 参照显示值 (有topName为树表, 树表时取meta中的显示字段)

  state = {
    dataSource: [], // 树数据
    selectedKeys: [], // 当前选中数据的id集合
    searchKey: '', // 查询关键词
    filterDataSource: [], // 过滤后的树数据
    expandedKeys: [], // 展开指定的树节点
    btnText: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C0003C', '全部选择', undefined, {returnDom: true, placement: 'top'}), // 按钮文字
    alias: uuid(), // 别名
    stopStatus: false, // 显示停用状态
    isAllSelected: false, // 是否全选
  }

  componentDidMount () {
    this.getDataList(); // 获取树数据
    // 初始化已选值
    let selectedList = this.referContext.getCurrentValue() // 从referContext获取当前选择的值
    selectedList.length > 0 && this.setState({ selectedKeys: selectedList.map(item => item[this.key]) });
  }

  // 获取列表数据
  getDataList = async () => {
    this.setState({ isLoading: true });
    this.referContext.props.pageStore.startLoading()
    let dataSource = await this.referContext.getListData({
      referType: REFER_TYPE.TREE, dataType: 'tree',
      billnum: this.billNo,
      busiObj: this.busiObj,
      stopStatus: this.props.showStopStatus ? this.state.stopStatus : undefined
    });
    this.setLevelPath(dataSource, '')
    if (this.props.topName) {
      dataSource = [{
        [this.key]: "all",
        [this.name]: this.props.topName,
        children: [...dataSource]
      }]
    }
    this.setState({ dataSource: dataSource || [], isLoading: false });
    this.referContext.props.pageStore.endLoading()
  }

  // 给每一级的数据加path
  setLevelPath = (data, path) => {
    data.map(item => {
      item.path = path + item[this.key] + '|';
      if (item.children && item.children.length > 0) {
        this.setLevelPath(item.children, item.path)
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.searchKey !== this.props.searchKey) {
      this.onSearch(nextProps.searchKey)
    }
  }

  // 查询关键词
  onSearch = (value) => {
    const { dataSource } = this.state;
    let filterDataSource = this.getParentKey(dataSource, value); // 
    let expandedKeys = [];
    value.length > 0 && this.expandedAllKeys(filterDataSource, expandedKeys) // 展开所有树节点
    this.setState({ filterDataSource, searchKey: value, expandedKeys });
  }

  // 搜索树节点,重新组装树
  getParentKey = (dataSource, value) => {
    let selecData = [];
    dataSource.forEach((item) => {
      if (item[this.name].indexOf(value) > -1) {
        if (item.children && item.children.length > 0) {
          let children = this.getParentKey(item.children, value);
          if (children.length > 0) {
            selecData.push({...item, children: children})
          } else {
            selecData.push({...item, children: undefined})
          }
        } else {
          selecData.push(item)
        }
      } else if (item.children && item.children.length > 0) {
        let children = this.getParentKey(item.children, value);
        if (children.length > 0) {
          selecData.push({...item, children: children})
        }
      }
    })
    return selecData;
  }

  // 监听选择
  onSelectRow = (row, action) => {
    this.referContext.props.onChangeSelect?.({
      oldValue: this.referContext.getCurrentValue(),
      currentValue: row
    });
    const { dataSource } = this.state;
    /**
     * 树表时不做存值(有topName说明是树表),把值通过updateValue传回去
     * referContext.select 将选择的值存入逻辑层
     */
    this.props.topName ? this.props.updateValue(row, dataSource) : this.referContext.select(row)
    // 如果是下拉展示方式, 则单选不用点确定直接关闭, 有topName是树表, 树表不能用下拉
    if (!this.props.isMultiple && this.props.topName === undefined && (this.referContext.showPopover || action === 'onDoubleClick')) { // 单选双击也可直接关闭
      this.referContext.okClick();
    }
    let selectedList = this.referContext.getCurrentValue(); // 从referContext获取当前选择的值
    this.setState({ selectedKeys: selectedList.map(item => item[this.key]) }); // 更新选择数据
  }

  // 渲染树配置项
  getTreeConfig = () => {
    const { selectedKeys, searchKey, expandedKeys, dataSource, alias, filterDataSource } = this.state;
    const { selectedTreeKeys } = this.props;
    const { fieldid, fieldidPrefix } = this.referContext.props;
    return {
      store: { // 树数据
        dataSource: searchKey.length > 0 ? filterDataSource : dataSource
      },
      fieldid,
      fieldidPrefix,
      libCode: X_LIB_CODE, // 组件库
      controlType: 'Tree', // 组件类型
      alias: alias, // 组件唯一标识
      checkable: this.props.isMultiple, // 节点前添加 Checkbox 复选框
      titleField: this.name, // 显示的字段名
      keyField: this.key, // key取值的字段名
      checkedKeys: selectedKeys, // 选中复选框的树节点
      selectedKeys: selectedTreeKeys ? selectedTreeKeys : selectedKeys, // 设置选中的树节点
      checkStrictly: true, // checkable 状态下节点选择完全受控（父子节点选中状态不再关联）
      searchValue: searchKey, // 查询的关键词(高亮样式用)
      expandedKeys: expandedKeys, // 展开指定的树节点
      showButton: this.props.isMultiple, // 多选树时展示包含同级/包含下级按钮
      selectable: true,
      showLine: true, // 是否显示连接线
      showAddNode: false,
      onCheck: this.onCheck,
      onSelect: this.onSelectTree,
      onDoubleClick: this.onDoubleClick,
      onExpand: (expandedKeys) => { // 展开/收起节点时触发的回调函数
        this.setState({ expandedKeys });
      },
      sameLevelClick: this.sameLevelClick,
      nextLevelClick: this.nextLevelClick
    }
  }

  // Tree 点击复选框触发的回调方法 多选
  onCheck = (checkedKeys) => {
    const { dataSource } = this.state;
    let arr = checkedKeys.map(item => {
      return this.getNameByKey(dataSource, item)
    })
    this.onSelectRow(arr);
  }

  // Tree 点击树节点触发的回调函数 单选
  onSelectTree = (selectKeys) => {
    const { dataSource } = this.state;
    if (!this.props.isMultiple) { // 该回调在多选时也会执行,所以过滤一下
      if (selectKeys.length > 0) {
        let arr = [this.getNameByKey(dataSource, selectKeys[0])];
        this.onSelectRow(arr);
      } else {
        this.onSelectRow([]);
      }
    }
  }

  // Tree 当双击发生触发的方法
  onDoubleClick = (selectKeys) => { 
    const { dataSource } = this.state;
    if (!this.props.isMultiple) {
      let arr = [this.getNameByKey(dataSource, selectKeys)];
      this.onSelectRow(arr, 'onDoubleClick');
    }
  }

  // Tree 点击包含同级按钮回调(多选)
  sameLevelClick = (val) => {
    const { dataSource, selectedKeys } = this.state;
    let paths = val.path.split('|');
    let level = paths.length - 1;
    let levelArr = []; // 同级的所有数据
    this.onClickSameLevel(dataSource, paths, level, levelArr)
    let levelArrId = levelArr.map(i => i[this.key]); // 同级的所有数据id
    let selectedList = this.referContext.getCurrentValue(); // 从referContext获取当前选择的值
    if (this.isSubset(selectedKeys, levelArrId)) { // 如果levelArr是selectedKeys的子集, 就反选
      let newSelected = [];
      selectedList.forEach(item => {
        if (!levelArrId.includes(item[this.key])) {
          newSelected.push(item)
        }
      })
      this.onSelectRow(newSelected)
    } else {
      this.onSelectRow([...selectedList, ...levelArr])
    }
  }

  // Tree 点击包含下级按钮回调(多选)
  nextLevelClick = (val) => {
    const { selectedKeys } = this.state;

    const list = [...val.children]
    let node = list.shift()
    const allChild = []
    while (node) {
      allChild.push(node)
      node.children && list.push(...node.children)
      node = list.shift()
    }
    let nextArr = [ val, ...allChild ]; // 下级的所有数据

    let nextArrId = nextArr.map(i => i[this.key]); // 下级的所有数据id
    let selectedList = this.referContext.getCurrentValue(); // 从referContext获取当前选择的值
    if (this.isSubset(selectedKeys, nextArrId)) { // 如果nextArrId是selectedKeys的子集, 就反选
      let newSelected = [];
      selectedList.forEach(item => {
        if (!nextArrId.includes(item[this.key])) {
          newSelected.push(item)
        }
      })
      this.onSelectRow(newSelected)
    } else {
      this.onSelectRow([...selectedList, ...nextArr])
    }
  }

  // 根据key查找对应的数据
  getNameByKey = (dataSource, key) => {
    for (let i = 0; i < dataSource.length; i++) {
      let item = dataSource[i];
      if (item[this.key] === key) {
        return item;
      } else if (item.children && item.children.length > 0) {
        let obj = this.getNameByKey(item.children, key);
        if (obj) {
          return obj;
        }
      }
    }
  }

  // 查找同级元素(包含同级用)
  onClickSameLevel = (dataSource, paths, level, levelArr) => {
    let i;
    dataSource.forEach((item, index) => {
      if (item[this.key] === paths[paths.length - level - 1]) {
        i = index;
      }
    })
    if (level > 1) {
      level--;
      dataSource[i].children && this.onClickSameLevel(dataSource[i].children, paths, level, levelArr);
    } else {
      levelArr.push(...dataSource)
    }
  }
  
  // 判断a数组是否包含b数组
  isSubset = (a, b) => {
    const len = b.length;
    if (a.length < len) return false;
    for (let i = 0; i < len; i++) {
      if (!a.includes(b[i])) return false;
    }
    return true;
  }

  // 单选时展示层级面包屑
  getShowValue = (dataSource, selectedKey) => {
    let text = ''
    dataSource.forEach(item => {
      if (item[this.key] === selectedKey) {
        text = item[this.name];
      } else if (item.children && item.children.length > 0) {
        let childText = this.getShowValue(item.children, selectedKey);
        if (childText.length > 0)
          text = `${item[this.name]} / ${childText}`;
      }
    });
    return text;
  }

  // 下拉菜单动作
  onSelectMenu = (info) => {
    const { dataSource } = this.state;
    let expandedKeys = [];
    switch (info.key) {
      case '1': // 全部展开
        this.expandedAllKeys(dataSource, expandedKeys)
        this.setState({ expandedKeys });
        break;
      case '2': // 全部收起
        this.setState({ expandedKeys: [] });
        break;
      case '3': // 展开1级
        this.setState({ expandedKeys: dataSource.map(item => item[this.key]) });
        break;
      case '4': // 展开2级
        dataSource.forEach(item => {
          expandedKeys.push(item[this.key])
          if (item.children && item.children.length > 0) {
            item.children.forEach(child => expandedKeys.push(child[this.key]))
          }
        });
        this.setState({ expandedKeys });
        break;
      default:
        break;
    }
  }

  // 递归遍历所有节点的id(展开所有树节点用)
  expandedAllKeys = (dataSource, expandedKeys) => {
    dataSource.forEach(item => {
      expandedKeys.push(item[this.key])
      if (item.children && item.children.length > 0)
        this.expandedAllKeys(item.children, expandedKeys)
    });
  }

  // 全部选择/全部取消
  selectAll = () => {
    let { btnText, dataSource } = this.state;
    if (btnText === lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C0003C', '全部选择', undefined, {returnDom: true, placement: 'top'})) {
      let checkedArr = [];
      this.selectAllData(dataSource, checkedArr)
      this.onSelectRow(checkedArr);
      this.setState({ btnText: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C0003B', '全部取消', undefined, {returnDom: true, placement: 'top'}) });
    } else {
      this.onSelectRow([]);
      this.setState({ btnText: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C0003C', '全部选择', undefined, {returnDom: true, placement: 'top'}) });
    }
    this.setState({ isAllSelected: !this.state.isAllSelected });
  }

  // 全部选择
  selectAllData = (dataSource, checkedArr) => {
    dataSource.forEach(item => {
      checkedArr.push({
        [this.key]: item[this.key],
        [this.name]: item[this.name]
      })
      if (item.children && item.children.length > 0)
        this.selectAllData(item.children, checkedArr)
    });
  }

  // shouldComponentUpdate(nextProps) {
  //   if (nextProps.selectedTreeKeys && nextProps.selectedTreeKeys.length > 0) {
  //     return false
  //   }
  //   return true
  // }

  getFieldId = () => {
    const { fieldid, fieldidPrefix } = this.referContext.props || {};
    return fieldid || fieldidPrefix;
  };

  render () {
    const { dataSource, searchKey, selectedKeys, btnText, stopStatus, filterDataSource, isLoading } = this.state;
    let showText = this.getShowValue(dataSource, selectedKeys[0]);
    const menu = (<Menu onSelect={this.onSelectMenu} fieldid={`${this.getFieldId()}`}>
      <Item key="1">{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C0003D', '全部展开', undefined, {returnDom: true, placement: 'top'})}</Item>
      <Item key="2">{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C0003F', '全部收起', undefined, {returnDom: true, placement: 'top'})}</Item>
      <Item key="3">{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00040', '展开1级', undefined, {returnDom: true, placement: 'top'})}</Item>
      <Item key="4">{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00041', '展开2级', undefined, {returnDom: true, placement: 'top'})}</Item>
    </Menu>);

    return (
      <div className='refer-table-list'>
        { !this.props.dropdown && !this.props.topName && !this.props.isMultiple ? 
          <div className='tree-single-text'>
            {showText.length > 0 ? showText : <span className='unselect'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00043', '未选择', undefined, {returnDom: true, placement: 'top'})}</span>}
          </div>
          : null
        }
        {/* 搜索 */}
        {
          !this.props.dropdown && 
          <div className='refer-search-container'>
            <Input type='search' onSearch={this.onSearch} showClose className='refer-search-input' placeholder={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C0003E', '请输入关键词', undefined, {returnDom: true, placement: 'top'})} fieldid={`${this.getFieldId()}_tree_search`} />
            { this.props.isMultiple && <Button className='dropdown-btn' onClick={this.selectAll} fieldid={`${this.getFieldId()}_tree_selectall`}>{btnText}</Button> }
            { !this.props.topName && !this.referContext.props.hiddenCtrlDropdown &&
              <Dropdown overlay={menu} className="dropdown-btn" getPopupContainer={() => document.getElementsByClassName('refer-table-list')[0]} fieldid={`${this.getFieldId()}_tree_dpd`}>
                <Button>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00042', '展开', undefined, {returnDom: true, placement: 'top'})}<Icon type="uf-anglearrowdown" fieldid={`${this.getFieldId()}_tree_dpd_btn`} /></Button>
              </Dropdown>
            }
            {
              this.props.showStopStatus ? 
              <Checkbox antd checked={stopStatus} onClick={(e) => { this.setState({ stopStatus: e.target.checked }, () => { this.getDataList() }) }} className='refer-search-checkbox' fieldid={`${this.getFieldId()}_tree_stopstatus`}>
                {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00044', '显示停用', undefined, {returnDom: true, placement: 'top'})}
              </Checkbox>
              : null
            }
          </div>
        }
        <div style={{ height: !this.props.topName && !this.props.isMultiple ? 'calc(100% - 86px)' : 'calc(100% - 50px)', overflow: 'auto' }}>
          {
            // 下拉展示方式
            this.props.dropdown ? 
              <div className='refer-dropdown-list'>
                {
                  isLoading ? <div className='loading'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1943095005580013', '加载中...', undefined, {returnDom: true, placement: 'top'})}</div>
                  :
                  dataSource.length > 0 ?
                    this.props.searchKey ?
                      filterDataSource.length > 0 ? render(this.getTreeConfig(), { rootStore: {} })
                      : <div className='loading'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1943095005580010', '暂无搜索结果', undefined, {returnDom: true, placement: 'top'})}</div>
                    : render(this.getTreeConfig(), { rootStore: {} })
                  : <div className='loading'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1943095005580011', '暂无数据', undefined, {returnDom: true, placement: 'top'})}</div>
                }
              </div>
            :
            render(this.getTreeConfig(), {
              rootStore: {}
            })
          }
        </div>
        {
          this.props.isMultiple && 
          <div className='yyrefer-popover-btn'>
            <Checkbox checked={this.state.isAllSelected} onChange={this.selectAll} fieldid={`${this.getFieldId()}_tree_selectall`}>
              {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_194309500558000F', '全选', undefined, {returnDom: true, placement: 'top'})}
            </Checkbox>
            <div>
              <Button className="cancel" onClick={this.referContext.closePopover} colors="secondary" fieldid={`${this.getFieldId()}_tree_cancle`}>
                {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1943095005580012', '取消', undefined, {returnDom: true, placement: 'top'})}
              </Button>
              <Button onClick={() => { this.referContext.okClick(); this.referContext.closePopover() }} colors='primary' fieldid={`${this.getFieldId()}_tree_ok`}>
                {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C0002F', '确定', undefined, {returnDom: true, placement: 'top'})}
              </Button>
            </div>
          </div>
        }
      </div>
    )
  }
}
